import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { matchPath, withRouter } from "react-router";

import * as routes from "../../../router/routes";
import Api from "../../../api";
import Profile from "./Profile";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // isSearchOpen: false,
      // search: props.searchString,
      selectedValue: props.defaultSearchValue,
      // isNotifyPopoverOpen: false,
      isProfilePopoverOpen: false
    };
    this.headerTitleRef = React.createRef();
    this.propfileRef = React.createRef();
    // this.handleSearchOpen = this.handleSearchOpen.bind(this);
    // this.handleSearchValue = this.handleSearchValue.bind(this);
    this.handleSelectValue = this.handleSelectValue.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePoppers = this.handlePoppers.bind(this);
    this.getTitle = this.getTitle.bind(this);
  }

  async componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, true);

    // await Api.notification.get();
    await Api.user.getUserInfo();
    await Api.subscription.get();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  getTitle() {
    const { titleComponent, user } = this.props;
    const headerTitle = user.company?.name;
    const typeSubscribe = "Expert";

    if (titleComponent) {
      return titleComponent();
    }
    if (headerTitle && typeSubscribe === user.company?.currentSubscription) {
      return (
        // <h3 title={headerTitle} className="header-title">
        //   {headerTitle}
        // </h3>
        <h1 className="title">{headerTitle}</h1>
      );
    }
    return (
      // <h3 className="header-title">Global Data Resources</h3>
      // <h1 className="title">Global Data Resources</h1>
      <h1 className="title">Audiences</h1>
    );
  }

  handleScroll = () => {
    const profileCoords = this.propfileRef?.current?.getBoundingClientRect();
    if (profileCoords?.y <= -50) {
      this.setState({ isProfilePopoverOpen: false });
    }
  };

  handlePoppers(stateField, newState) {
    return this.setState({
      isProfilePopoverOpen: false,
      [stateField]: newState
    });
  }

  // handleSearchOpen(isSearchOpen) {
  //   this.setState({ isSearchOpen });
  // }
  //
  // handleSearchValue(search) {
  //   this.setState({ search });
  // }

  handleSelectValue(selectedValue) {
    this.setState({ selectedValue });
  }

  handleSearch(string = "", evt = {}) {
    if (evt.action === "input-change") {
      this.handleSelectValue({});
      this.handleSearchValue(string);

      if (string.length >= 2) {
        const searchRequest = async () => {
          await Api.audience.search({ params: { search: string } });
          await Api.client.search({ params: { search: string } });
        };
        searchRequest();
      }

      return string;
    }
    this.handleSearchValue("");
    return this.state.selectedValue;
  }

  handleSelect(selected = {}) {
    const {
      searchDataClients,
      searchDataAudiences,
      searchFullDataAudiences,
      history,
      location
    } = this.props;
    if (selected && selected.value) {
      this.handleSelectValue(selected);
      if (searchDataClients.some(client => client.value === selected.value)) {
        return history.push(routes.clients(selected.value));
      }
      if (
        searchDataAudiences.some(audience => audience.value === selected.value)
      ) {
        const audience = searchFullDataAudiences.find(
          dataAudience => dataAudience.id === selected.value
        );

        return history.push({
          pathname: `${routes.fullReport}/${audience.id}/${audience.threshold}/audience`,
          state: audience
        });
      }
    }
    // value removed
    this.handleSelectValue({});
    const clientMatch = matchPath(location.pathname, {
      path: routes.clients(),
      exact: true,
      strict: false
    });
    const audienceMatch = matchPath(location.pathname, {
      path: routes.clients(),
      exact: true,
      strict: false
    });
    const query =
      (clientMatch && clientMatch.params && clientMatch.params.id) ||
      (audienceMatch && audienceMatch.params && audienceMatch.params.id) ||
      "";
    if (clientMatch && clientMatch.url) {
      history.replace(clientMatch.url.replace(query, ""));
    }
    if (audienceMatch && audienceMatch.url) {
      history.replace(audienceMatch.url.replace(query, ""));
    }
    return false;
  }

  render() {
    const {
      // notifications,
      user
      // searchDataClients,
      // searchDataAudiences,
      // withoutSearchAndNotifications
    } = this.props;
    const {
      // isSearchOpen,
      // search,
      // selectedValue,
      // isNotifyPopoverOpen,
      isProfilePopoverOpen
    } = this.state;

    // const selectData = [
    //   {
    //     label: "Audiences",
    //     options: searchDataAudiences
    //   },
    //   {
    //     label: "Clients",
    //     options: searchDataClients
    //   }
    // ];
    //
    // const widthForSearch = this.headerTitleRef?.current?.offsetWidth;

    return (
      <header className="header">
        <div ref={this.headerTitleRef} className="header-title-wrap">
          {this.getTitle()}
        </div>
        <div ref={this.propfileRef} className="header-tools">
          {/* {withoutSearchAndNotifications ? null : ( */}
          {/*  <> */}
          {/*    <div className="header-search"> */}
          {/*      <Button */}
          {/*        className={`btn-transparent header-icon-container search ${ */}
          {/*          isSearchOpen ? "hide" : "" */}
          {/*        }`} */}
          {/*        onClick={() => this.handleSearchOpen(!isSearchOpen)} */}
          {/*      > */}
          {/*        <SVG.HeaderSearch className="header-icon" /> */}
          {/*      </Button> */}
          {/*      <AsyncSelect */}
          {/*        components={{ DropdownIndicator, IndicatorSeparator }} */}
          {/*        styles={{ */}
          {/*          ...headerSearch, */}
          {/*          container: !isSearchOpen */}
          {/*            ? headerContainerHided */}
          {/*            : () => { */}
          {/*                return { */}
          {/*                  ...headerSearch.container(), */}
          {/*                  width: widthForSearch + 60 */}
          {/*                }; */}
          {/*              } */}
          {/*        }} */}
          {/*        isClearable */}
          {/*        deafultValue={selectedValue} */}
          {/*        inputValue={!selectedValue.value ? search : ""} */}
          {/*        options={selectData} */}
          {/*        noOptionsMessage={() => */}
          {/*          !search && search.length >= 2 */}
          {/*            ? "Please, type 2 character or more to start searching." */}
          {/*            : "No results." */}
          {/*        } */}
          {/*        loadingMessage={() => "Loading..."} */}
          {/*        onChange={this.handleSelect} */}
          {/*        onInputChange={this.handleSearch} */}
          {/*        placeholder="Search" */}
          {/*      /> */}
          {/*    </div> */}
          {/*    <Notification */}
          {/*      notifications={notifications} */}
          {/*      setState={newState => */}
          {/*        this.handlePoppers("isNotifyPopoverOpen", newState) */}
          {/*      } */}
          {/*      isOpen={isNotifyPopoverOpen} */}
          {/*    /> */}
          {/*  </> */}
          {/* )} */}

          <Profile
            user={user}
            setState={newState =>
              this.handlePoppers("isProfilePopoverOpen", newState)
            }
            isOpen={isProfilePopoverOpen}
          />
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  // notifications: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  user: PropTypes.shape({
    company: PropTypes.shape({
      name: PropTypes.string,
      currentSubscription: PropTypes.string
    })
  }).isRequired,
  // searchString: PropTypes.string.isRequired,
  searchDataClients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchDataAudiences: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchFullDataAudiences: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  defaultSearchValue: PropTypes.shape({}),
  titleComponent: PropTypes.func
  // withoutSearchAndNotifications: PropTypes.bool.isRequired
};

Header.defaultProps = {
  defaultSearchValue: {},
  titleComponent: null
};

const mapStateToProps = ({
  userProfile,
  notifications,
  clients,
  audiences
}) => {
  return {
    notifications: notifications.data,
    user: userProfile.user,
    searchString: clients.searchString || audiences.searchString,
    searchDataClients: clients.search.map(client => ({
      label: client.name,
      value: client.id
    })),
    searchDataAudiences: audiences.search.map(audience => ({
      label: audience.name,
      value: audience.id
    })),
    searchFullDataAudiences: audiences.search
  };
};

export default withRouter(connect(mapStateToProps, null)(Header));
